<template>
  <div>
    <h1 class="text-xl font-medium leading-6 text-gray-900 mr-2">Great! Let's start setting up your company.</h1>
    <p class="mt-1 text-sm text-gray-500">
      We'll use this for displaying your company's information throughout the app, job postings, and more.
    </p>

    <div v-if="loaded" class="mt-6 mb-6 grid grid-cols-1 gap-x-4 gap-y-8 max-w-sm mx-auto">
      <TextInput
        label="Company Name"
        placeholder="John"
        :model-value="team.company"
        @update:model-value="
          value => {
            team.company = value;
          }
        "
      />
      <FileInput
        label="Company Logo"
        limits="any Image"
        :imageholder="team.companyLogo"
        :model-value="team.companyLogoFile"
        accept="image/*"
        @update:model-value="team.companyLogoFile = $event"
      />
    </div>

    <div class="py-3 flex justify-center">
      <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <TButton
          color="amber"
          label="Next Step"
          :disabled="!team.company || (!team.companyLogoFile && !team.companyLogo)"
          @click="nextStep"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue-sonner';

export default {
  data() {
    return {
      team: {
        id: '',
        company: '',
        companyLogo: '',
        companyLogoFile: null,
      },
      loaded: false,
      companyCompleted: false,
    };
  },
  watch: {
    companyCompleted(newValue) {
      if (newValue) {
        this.$emit('go-forward');
      }
    },
  },
  async mounted() {
    await this.getTeam();
  },
  methods: {
    async getTeam() {
      const response = await fetch('/api/team');
      const data = await response.json();
      this.team.id = data.record.id;
      this.team.company = data.record.company;
      this.team.companyLogo = data.record.logo;
      this.loaded = true;
      this.companyCompleted = this.team.company && this.team.companyLogo ? true : false;
    },
    goBack() {
      this.$emit('go-back');
    },
    nextStep() {
      const self = this;
      let formData = new FormData();
      formData.append('company', self.team.company);
      self.team.companyLogoFile ? formData.append('company_logo', self.team.companyLogoFile) : null;
      fetch('/api/team', {
        method: 'PUT',
        body: formData,
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.status != 'error') {
            self.$emit('go-forward');
          } else {
            toast.error('Profile update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
